<template>
  <v-layout row wrap my-3 mx-2>
    <v-flex xs6 px-2>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Build Template
        </v-card-title>
        <v-card-actions class="px-3">
            <input
              type="file"
              style="display: none"
              ref="file"
              accept="csv/*"
              @change="onFilePicked"
            >
          <v-progress-linear  height="10"  v-if="upload>0 && upload<100" color="green darken-3" v-model="upload"></v-progress-linear>
          <v-progress-linear  height="10"  v-if="loading && upload == 100" color="green darken-3" indeterminate></v-progress-linear>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-layout row wrap px-2>
          <v-flex xs12 px-1>
            <v-select
              :items="templates"
              v-model="selectedTemplate"
              label="Load a saved Template"
              append-outer-icon="add"
              @click:append-outer="newTemplate"
              solo
            ></v-select>
          </v-flex>
          <v-flex xs12 px-1>
            <v-text-field
              label="Template Name"
              solo
              v-model="templateName"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 px-1>
            <v-select
              :items="['44794551515']"
              label="From Number"
              solo
              v-model="fromNumber"
              append-outer-icon="add"
              @click:append-outer=""
            ></v-select>
          </v-flex>
          <v-flex xs12 pa-1>
            <span class="my-3">Use <span class="red--text">|Firstname|</span> &/OR <span class="red--text">|Lastname|</span> to include name</span>
            <v-textarea
              solo
              label="Message"
              v-model="sMessage"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-card-actions class="px-3">
          <v-spacer></v-spacer>
          <v-btn 
            outline 
            color="error" 
            dark
            v-if="selectedKey"
            @click="dialog = true"
          >delete template</v-btn>
          
          <v-btn 
            @click="saveTemplate()"  
            color="primary" 
            :loading="loading"
            dark>
            {{ selectedKey ? 'Update' : 'Save Template'}}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="390">
        <v-card>
          <v-card-title class="headline">Are You Sure?</v-card-title>
          <v-card-text>
            You are about to delete template {{ templateName }}, are you sure you want to do that?
            <div class="error white--text pa-2 ma-3">NOTE: all data associated with template {{ templateName }} will be deleted completely from our servers, and it will be impossible to restore it</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="dialog = false">cancel</v-btn>
            <v-btn 
              color="success" 
              outline 
              @click="()=>{ deleteTemplate(); dialog = false  }"
            >confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs6  px-2>
      <v-card
        class="pa-2 mb-5 
        elevation-6"
        
      >
        <v-card-title class="headline white--text primary" >
          Preview
        </v-card-title>
        <div
          v-on:dragstart="getRight()" 
          @click.right="getRight()" 
          @click.left="getRight()"
        >
          <v-textarea
              class="my-3"
              solo
              label="SMS PREVIEW"
              v-model="sMessage"
              readonly
            ></v-textarea>
        </div>
        
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import { storageRef, firebase, db, auth } from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import emailT from './emailTemplate'


export default {
  components:{emailT}, 
  data() {
    return {
      uploadURL:null,
      name:null,
      file:null,
      loading:false,
      sNumber:null,
      sMessage:null,
      csv:null,
      qr:null,
      upload:null,
      messagesH:[],
      messages:[],
      detailedViewsHeaders:[],
      detailedViews:[],
      contacts:[],
      contactedNumbers:[],
      selectedNumber:null,
      selected:[],
      selectedNumberChat:null,
      chatMessages:[],
      myMSGS:[],
      clientMSGS:[],
      numbersMass:[],
      fileUploading:null,
      imgURL:null,
      logoURL:null,
      templateName:null,
      buttonURL:null,
      buttonText:null,
      footerText:null,
      emailSubject:null,
      fromEmail:null,
      fromNumber:null,
      fromName:null,
      language:null,
      emailSubject:null,
      selectedTemplate:[],
      templates:[],
      loadedTemplates:null,
      selectedKey:null,
      dialog:false
    }
  },
  methods: {
    getRight(e) {
      e = e || window.event;
      e.preventDefault()
    },
    deleteTemplate() {
      if(!this.selectedKey) return true
      db.ref('sms/templates')
      .update({[this.selectedKey]:null})
      .then(y=>{
        let index = this.templates.findIndex(x => x.value === this.selectedKey)
        console.log(index)
        this.templates.splice(index, 1)
        this.newTemplate()
      })
    },
    getTemplates(){
      return db.ref('sms/templates')
      .on('value', t=>{
        let templates = t.val()
        this.loadedTemplates = templates
        console.log(templates)
        for (const key in templates) {
            if (templates.hasOwnProperty(key)) {
              const template = templates[key];
              this.templates.push({
                text:template.templateName,
                value:key
              })
            }
        }
      })
    },
    saveTemplate(){
      let template = {
        templateName: this.templateName,
        smsBody: this.sMessage,
        fromNumber: this.fromNumber,
      }
      console.log(template)
      if(!this.selectedKey) {
        db.ref('sms/templates')
        .push(template)
        .then(x=>{
          this.newTemplate()
        })
      } else {
        db.ref('sms/templates/' + this.selectedKey)
        .update(template)
        .then(x=>{
          this.newTemplate()
        })
      }
    },
    goTo(path) {
      this.$router.push(path)
    },
    pickFile (f) {
      this.$refs.file.click ()
      this.fileUploading = f
    },
    loadFile(file){
      var file = file
      var metadata = {
        contentType: 'image/jpeg'
      };
      var uploadTask = storageRef.child('images/' + randomString(8, 'Aa#') + '.jpg').put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.upload = progress
                }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.uploadURL = downloadURL
          if(this.fileUploading == 'img') {
            this.imgURL = downloadURL
          } else if(this.fileUploading == 'logo') {
            this.logoURL = downloadURL
          }
          this.loading = false
        });
      });
    },
    onFilePicked (e) {
      this.loading = true
			const files = e.target.files
			if(files[0] !== undefined) {
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFile(this.file)
				})
			} else {
				this.name = null
				this.fule = null
				this.uploadURL = null
			}
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    newTemplate(){
      this.templateName =  null
      this.sMessage =  null
      this.fromNumber =  null
      this.selectedKey =  null
      this.selectedTemplate =  null
    }
  },
  computed:{
    
  },
  watch:{
    selectedTemplate() {
      if (!this.selectedTemplate) return
      console.log(this.loadedTemplates[this.selectedTemplate])
      let t = this.loadedTemplates[this.selectedTemplate]
      this.templateName = t.templateName
      this.sMessage = t.smsBody
      this.fromNumber = t.fromNumber
      this.selectedKey = this.selectedTemplate
    }
  },
  created() {
    this.getTemplates() 
    let DB = (ref) => {
      return db.ref(ref)
      .once('value')
      .then(x=>{ return x.val()})
    } 

    
    DB('whatsapp/numbers').then(e=>{
      console.log(e)
    })
  }
}
</script>

<style>

</style>
